import {IMessage} from '@scalified-monorepo/shared';

export const getContextOrTraceId = (message: IMessage): string | undefined => {
  return message.metadata?.contextId || message.metadata?.traceId;
};

export function getSseEventData(e: MessageEvent) {
  if (!e.data) return false;

  const data: IMessage = JSON.parse(e.data);

  return !!(data.type && getContextOrTraceId(data)) && data;
}
